/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Add_FailedInputs */



/**
* | output |
* | --- |
* | "We could not add it. Try again in a moment." |
*
* @param {Agenda_Add_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_add_failed = /** @type {((inputs?: Agenda_Add_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Add_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toevoegen is niet gelukt. Probeer het zo opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'ajout n'a pas fonctionné. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not add it. Try again in a moment.")
});